module.exports = __webpack_public_path__ + "static/fonts/BebasNeue-1.51b4a619.otf";